module.exports = "https://static.wmbcdn.com/uniweb/images/0c4f92bafedbd179a777bf44ba8d7055.svg";